import { sha512 } from "js-sha512";

// Legacy API parameter handling and form checksums
export const legacyApiInterceptor = {
   request: (config) => {
      const locationKey = sessionStorage.getItem("locationKey");

      // Add locationKey parameter to php legacy POST and PUT requests
      if (
         config.method === "post" &&
         config.url.includes("legacy") &&
         (config.data.httpMethod === "POST" || config.data.httpMethod === "PUT")
      ) {
         const params = config.data.parameters;

         if (params) {
            if (params.charAt(0) === "/") {
               // URL params format
               const newParameters = JSON.parse(params.substring(1, params.length));
               newParameters.locationKey = locationKey;
               config.data.parameters = `/${JSON.stringify(newParameters)}`;
            } else {
               // Standard params format
               const newParameters = JSON.parse(params);
               newParameters.locationKey = locationKey;
               config.data.parameters = JSON.stringify(newParameters);
            }
         } else {
            config.data.parameters = `{"locationKey":"${locationKey}"}`;
         }

         // Add checksum for forms-v2 endpoints
         if (
            config?.data?.endpoint === "/forms-v2" &&
            (config?.data?.httpMethod === "POST" || config?.data?.httpMethod === "PUT")
         ) {
            const checksum = sha512
               .hmac(process.env.REACT_APP_LIST_DATA, config.data.body)
               .toLowerCase();

            config.headers = {
               ...config.headers,
               checksum,
            };
         }
      }

      return config;
   },
};
